import {
  Activity,
  Bath,
  Bed,
  Briefcase,
  Calculator,
  ChefHat,
  Coffee,
  Dumbbell,
  FlaskConical,
  FolderOpen,
  PenTool,
  ShoppingCart,
  Sparkles,
  User,
  Utensils,
  WashingMachine,
  Zap,
  Tag,
  Smile,
  Heart,
  Star,
  CheckCircle2,
  HelpCircle,
  Plane,
  Car,
  Bike,
  Music,
  Gamepad2,
  Tv,
  Film,
  Camera,
  Moon,
  Sun,
  Cloud,
  Palmtree,
  Flower,
  Leaf,
  Apple,
  Stethoscope,
  Brain,
  GraduationCap,
  Book,
  Laptop,
  Mail,
  ClipboardList,
  ShoppingBag,
  Gift,
  PartyPopper,
  Trophy,
  PawPrint,
  Globe,
  Wifi,
  Lock,
  MapPin,
  Calendar,
  Bell,
} from "lucide-react";
import React from "react";

export const EVENT_ICON_MAP: Record<string, React.ElementType> = {
  Tag,
  Briefcase,
  User,
  Utensils,
  Coffee,
  ChefHat,
  Dumbbell,
  ShoppingCart,
  PenTool,
  Calculator,
  FlaskConical,
  Zap,
  Activity,
  WashingMachine,
  Bed,
  Bath,
  Sparkles,
  FolderOpen,
  Smile,
  Heart,
  Star,
  CheckCircle2,
  HelpCircle,
  Plane,
  Car,
  Bike,
  Music,
  Gamepad: Gamepad2,
  Tv,
  Film,
  Camera,
  Moon,
  Sun,
  Cloud,
  PalmTree: Palmtree,
  Flower,
  Leaf,
  Apple,
  Stethoscope,
  Brain,
  GraduationCap,
  Book,
  Laptop,
  Mail,
  ClipboardList,
  ShoppingBag,
  Gift,
  PartyPopper,
  Trophy,
  PawPrint,
  Globe,
  Wifi,
  Lock,
  MapPin,
  Calendar,
  Bell,
};

export const ICON_OPTIONS = Object.entries(EVENT_ICON_MAP).map(
  ([name, icon]) => ({
    name,
    icon,
  }),
);
